const seoConfig = {
  home: {
    title:
      "УрНИИДВИ – Уральский научно-исследовательский институт дерматовенерологии и иммунопатологии",
    description:
      "Официальный сайт УрНИИДВИ. Клиника, научные исследования, образование и помощь пациентам.",
    keywords: "УрНИИДВИ, дерматовенерология, инфекционные заболевания, клиника",
  },

  about: {
    title: "Об институте УрНИИДВИ",
    description:
      "История, структура и деятельность Уральского НИИ дерматовенерологии и иммунопатологии.",
    keywords: "УрНИИДВИ история, структура института",
  },

  science: {
    title: "Научная деятельность УрНИИДВИ",
    description:
      "Научные исследования, разработки и клинические испытания УрНИИДВИ.",
    keywords: "научные исследования дерматология",
  },

  clinic: {
    title: "Клиника УрНИИДВИ – медицинские услуги",
    description:
      "Диагностика и лечение кожных и инфекционных заболеваний в клинике УрНИИДВИ.",
    keywords: "клиника дерматология лечение",
  },

  education: {
    title: "Образование в УрНИИДВИ",
    description:
      "Ординатура, аспирантура и дополнительное образование в УрНИИДВИ.",
    keywords: "ординатура дерматология обучение",
  },

  patients: {
    title: "Пациентам УрНИИДВИ",
    description:
      "Запись на прием, услуги, специалисты и информация для пациентов.",
    keywords: "запись к врачу дерматолог",
  },

  contacts: {
    title: "Контакты УрНИИДВИ",
    description: "Контактная информация, адрес и схема проезда УрНИИДВИ.",
    keywords: "контакты УрНИИДВИ адрес",
  },

  papillomaRemoval: {
    title: "Удаление папиллом в Екатеринбурге – УрНИИДВиИ",
    description:
      "Безопасное удаление папиллом в УрНИИДВиИ. Современные методы, опытные врачи, консультация и лечение кожных новообразований.",
    keywords:
      "удаление папиллом, папилломы лечение, дерматолог Екатеринбург, удаление новообразований",
  },
};

export default seoConfig;
